export interface BookType {
  id: BookTypeID
  name: 'A' | 'B' | 'C'
}

export enum BookTypeID {
  A = 1,
  B = 2,
  C = 3,
}

export const BookTypeIdToFriendlyName: Record<BookTypeID, string> = {
  [BookTypeID.A]: 'A',
  [BookTypeID.B]: 'B',
  [BookTypeID.C]: 'C',
}
